export default {
  en: {
    "leads.label.leads": "Leads",
    "leads.label.user": "User",
    "leads.label.email_id": "Email Id",
    "leads.label.address": "Address",
    "leads.label.phone_number": "Phone Number",
    "leads.label.name": "Name",
    "leads.label.remark": "Remark",
    "leads.label.status": "Status",
    "leads.label.action": "Actions",
    "leads.label.new_lead": "New Lead",
    "leads.label.close_leads": "Close Leads",
    "leads.label.status_remark": "Status Remark",
    "leads.label.cancel": "Cancel",
    "leads.label.save": "Save",
    "leads.label.confirm": "Confirm",
    "leads.label.createticket": "Create Ticket",
    "leads.label.totalrecords": "Total Records",
    "leads.label.uploadprocess": "Upload Process",
    "leads.label.uploadfilepath": "Upload File Path",
    "leads.label.processingdate": "Processing Date",
    "leads.label.follow_up": "Follow Up",
    "leads.label.call_status": "Call Status",
    "leads.label.next_call_date_time": "Next Call Date & Time",
    "leads.label.assigned_to": "Assigned To",
    "leads.label.note": "Note",
    "leads.label.create_lead": "Create Lead",
    "leads.label.personal_details": "Personal Details",
    "leads.label.BusinessEntityCode": "Business Entity Code",
    "leads.label.first_name": "First Name",
    "leads.label.middle_name": "Middle Name",
    "leads.label.last_name": "Last Name",
    "leads.label.mobile_number": "Mobile Number",
    "leads.label.office_number": "Office Number",
    "leads.label.next": "Next",
    "leads.label.address_details": "Address Details",
    "leads.label.city_area": "City/Area",
    "leads.label.street_area": "Street/Area",
    "leads.label.state": "State",
    "leads.label.country": "Country",
    "leads.label.zip_code": "Zip Code",
    "leads.label.source_details": "Source Details",
    "leads.label.source": "Source",
    "leads.label.service": "Service",
    "leads.label.next_call_date_time": "Next Call Date & Time",
    "leads.label.complete": "Complete",
    "leads.label.submit": "Submit",
    "leads.label.previous": "Previous",
    "leads.label.done": "Done",
    "leads.label.personal_details": "PERSONAL DETAILS",
    "leads.label.address_details": "ADDRESS DETAILS",
    "leads.label.source_details": "SOURCE DETAILS",
    "leads.label.go_back_to_leads_list": "Go back to Leads List",
    "leads.label.district": "District",
    "leads.label.leads_details": "Leads Details",
    "leads.label.customer_view": "Customer View",
    "leads.label.follow_up": "Follow Up",
    "leads.label.assign_to": "Assign To",
    "leads.label.elevate_prospect": "Elevate Prospect",
    "leads.label.generate_quotation": "Generate Quotation",
    "leads.label.convert_to_customer": "Convert to Customer",
    "leads.label.edit": "Edit",
    "leads.label.history_data": "History Data",
    "leads.label.call_status": "Call Status",
    "leads.label.next_call": "Next Call",
    "leads.label.quotations": "Quotations",
    "leads.label.quote_id": "Quote Id",
    "leads.label.quote_number": "Quote Number",
    "leads.label.lead_id": "Lead Id",
    "leads.label.total_charge": "Total Charge",
    "leads.label.generate_quote": "Generate Quote",
    "leads.label.delete_service_plan": "Delete Service Plan?",
    "leads.label.personal_details": "Personal Details",
    "leads.label.quote_status": "Quote Status",
    "leads.label.quote_date": "Quote Date",
    "leads.label.customer_id": "Customer Id",
    "leads.label.customer_name": "Customer Name",
    "leads.label.plan": "Plan",
    "leads.label.frequency": "Frequency",
    "leads.label.recurring_charge": "Recurring Charge",
    "leads.label.one_time_charge": "One Time Charge",
    "leads.label.add": "Add",
    "leads.label.service_code": "Service Code",
    "leads.label.exists_service_plans": "Exists Service Plans",
    "leads.label.plan_name": "Plan Name",
    "leads.label.reset": "Reset",
    "leads.label.edit_quote": "Edit Quote",
    "leads.label.cancel_lead": "Cancel Lead",
    "leads.label.status_remark": "Status Remark",
    "leads.label.delete": "Delete",
    "leads.label.quote_details": "Quote Details",
    "leads.label.quotation_date": "Quotation Date",
    "leads.label.quotation": "Quotation",
    "leads.label.price": "Price",
    "leads.label.product": "Product",
    "leads.label.charge_type": "Charge Type",
    "leads.label.rate_uom": "Rate/UOM",
    "leads.label.download": "Download",
    "leads.label.service_plan": "Service Plan",
    "leads.label.ADDRESSDETAILS": "ADDRESS DETAILS",
    "leads.label.Individual": "Individual",
    "leads.label.Corporate": "Corporate",
    "leads.label.Type": "Type",
    "leads.label.EditLead": "Edit Lead",
  },
  fr: {
    "leads.label.leads": "Leads",
    "leads.label.user": "Utilisateur",
    "leads.label.email_id": "Identifiant e-mail",
    "leads.label.address": "Adresse",
    "leads.label.phone_number": "Numéro de téléphone",
    "leads.label.user": "Utilisateur",
    "leads.label.name": "Nom",
    "leads.label.remark": "Remarque",
    "leads.label.status": "Statut",
    "leads.label.action": "Action",
    "leads.label.new_lead": "Nouveau Prospect",
    "leads.label.close_leads": "Fermer les pistes",
    "leads.label.status_remark": "Remarque sur le statut",
    "leads.label.cancel": "Annuler",
    "leads.label.save": "Sauvegarder",
    "leads.label.confirm": "Confirmer",
    "leads.label.createticket": "Créer un Ticket",
    "leads.label.totalrecords": "Total des Enregistrements",
    "leads.label.uploadprocess": "Processus de Téléchargement",
    "leads.label.uploadfilepath": "Chemin du Fichier de Téléchargement",
    "leads.label.processingdate": "Date de Traitement",
    "leads.label.follow_up": "Suivi",
    "leads.label.call_status": "État d'appel",
    "leads.label.next_call_date_time": "Prochaine date et heure d'appel",
    "leads.label.assigned_to": "Assigné à",
    "leads.label.note": "Remarque",
    "leads.label.create_lead": "Créer un prospect",
    "leads.label.personal_details": "Détails personnels",
    "leads.label.BusinessEntityCode": "Code d'Entité Commerciale",
    "leads.label.first_name": "Prénom",
    "leads.label.middle_name": "Deuxième prénom",
    "leads.label.last_name": "Nom de famille",
    "leads.label.mobile_number": "Numéro de portable",
    "leads.label.office_number": "Numéro de bureau",
    "leads.label.next": "Suivant",
    "leads.label.address_details": "Détails de l'adresse",
    "leads.label.city_area": "Ville/Zone",
    "leads.label.street_area": "Rue/Zone",
    "leads.label.state": "État",
    "leads.label.country": "Pays",
    "leads.label.zip_code": "Code postal",
    "leads.label.source_details": "Détails de la source",
    "leads.label.source": "Source",
    "leads.label.service": "Service",
    "leads.label.next_call_date_time": "Prochaine date et heure d'appel",
    "leads.label.complete": "Complet",
    "leads.label.submit": "Soumettre",
    "leads.label.previous": "Précédent",
    "leads.label.done": "Terminé",
    "leads.label.personal_details": "DÉTAILS PERSONNELS",
    "leads.label.address_details": "DÉTAILS D'ADRESSE",
    "leads.label.source_details": "DÉTAILS DE LA SOURCE",
    "leads.label.go_back_to_leads_list": "Retour à la liste des prospects",
    "leads.label.district": "District",
    "leads.label.leads_details": "Détails des prospects",
    "leads.label.customer_view": "Vue client",
    "leads.label.follow_up": "Suivi",
    "leads.label.assign_to": "Assigner à",
    "leads.label.elevate_prospect": "Élever le prospect",
    "leads.label.generate_quotation": "Générer un devis",
    "leads.label.convert_to_customer": "Convertir en client",
    "leads.label.edit": "Modifier",
    "leads.label.history_data": "Données historiques",
    "leads.label.call_status": "État de l'appel",
    "leads.label.next_call": "Prochain appel",
    "leads.label.quotations": "Devis",
    "leads.label.quote_id": "Identifiant du devis",
    "leads.label.quote_number": "Numéro du devis",
    "leads.label.lead_id": "Identifiant du prospect",
    "leads.label.total_charge": "Charge totale",
    "leads.label.generate_quote": "Générer un devis",
    "leads.label.delete_service_plan": "Supprimer le plan de service ?",
    "leads.label.personal_details": "Détails personnels",
    "leads.label.quote_status": "Statut du devis",
    "leads.label.quote_date": "Date du devis",
    "leads.label.customer_id": "Identifiant du client",
    "leads.label.customer_name": "Nom du client",
    "leads.label.plan": "Plan",
    "leads.label.frequency": "Fréquence",
    "leads.label.recurring_charge": "Frais récurrents",
    "leads.label.one_time_charge": "Frais ponctuels",
    "leads.label.add": "Ajouter",
    "leads.label.service_code": "Code de service",
    "leads.label.exists_service_plans": "Plans de service existants",
    "leads.label.plan_name": "Nom du plan",
    "leads.label.reset": "Réinitialiser",
    "leads.label.edit_quote": "Modifier le devis",
    "leads.label.cancel_lead": "Annuler le prospect",
    "leads.label.status_remark": "Remarque sur le statut",
    "leads.label.delete": "Supprimer",
    "leads.label.quote_details": "Détails de la citation",
    "leads.label.quotation_date": "Date de la citation",
    "leads.label.quotation": "Citation",
    "leads.label.price": "Prix",
    "leads.label.product": "Produit",
    "leads.label.charge_type": "Type de charge",
    "leads.label.rate_uom": "Taux/UOM",
    "leads.label.download": "Télécharger",
    "leads.label.service_plan": "Plan de service",
    "leads.label.ADDRESSDETAILS": "DÉTAILS DE L'ADRESSE",
    "leads.label.Individual": "Individuel",
    "leads.label.Corporate": "Entreprise",
    "leads.label.Type": "Type",
    "leads.label.EditLead": "Modifier Prospect",
  },
  es: {
    "leads.label.leads": "Leads",
    "leads.label.user": "Usuario",
    "leads.label.email_id": "Identificación de correo electrónico",
    "leads.label.address": "Dirección",
    "leads.label.phone_number": "Número de teléfono",
    "leads.label.user": "Usuario",
    "leads.label.name": "Nombre",
    "leads.label.remark": "Observación",
    "leads.label.status": "Estado",
    "leads.label.action": "Acción",
    "leads.label.new_lead": "Nuevo Prospecto",
    "leads.label.close_leads": "Cerrar Leads",
    "leads.label.status_remark": "Comentario de estado",
    "leads.label.cancel": "Cancelar",
    "leads.label.save": "Guardar",
    "leads.label.confirm": "Confirmar",
    "leads.label.createticket": "Crear Ticket",
    "leads.label.totalrecords": "Total de Registros",
    "leads.label.uploadprocess": "Proceso de Carga",
    "leads.label.uploadfilepath": "Ruta del Archivo de Carga",
    "leads.label.processingdate": "Fecha de Procesamiento",
    "leads.label.follow_up": "Seguimiento",
    "leads.label.call_status": "Estado de llamada",
    "leads.label.next_call_date_time": "Próxima Fecha y Hora de Llamada",
    "leads.label.assigned_to": "Asignado a",
    "leads.label.note": "Nota",
    "leads.label.create_lead": "Crear Prospecto",
    "leads.label.personal_details": "Detalles Personales",
    "leads.label.BusinessEntityCode": "Código de Entidad Comercial",
    "leads.label.first_name": "Nombre",
    "leads.label.middle_name": "Segundo Nombre",
    "leads.label.last_name": "Apellido",
    "leads.label.mobile_number": "Número de teléfono móvil",
    "leads.label.office_number": "Número de oficina",
    "leads.label.next": "Siguiente",
    "leads.label.address_details": "Detalles de la dirección",
    "leads.label.city_area": "Ciudad/Área",
    "leads.label.street_area": "Calle/Área",
    "leads.label.state": "Estado",
    "leads.label.country": "País",
    "leads.label.zip_code": "Código Postal",
    "leads.label.source_details": "Detalles de la fuente",
    "leads.label.source": "Fuente",
    "leads.label.service": "Servicio",
    "leads.label.next_call_date_time": "Próxima Fecha y Hora de Llamada",
    "leads.label.complete": "Completar",
    "leads.label.submit": "Enviar",
    "leads.label.previous": "Anterior",
    "leads.label.done": "Hecho",
    "leads.label.personal_details": "DETALLES PERSONALES",
    "leads.label.address_details": "DETALLES DE DIRECCIÓN",
    "leads.label.source_details": "DETALLES DE LA FUENTE",
    "leads.label.go_back_to_leads_list": "Volver a la lista de prospectos",
    "leads.label.district": "Distrito",
    "leads.label.leads_details": "Detalles de los prospectos",
    "leads.label.customer_view": "Vista de cliente",
    "leads.label.follow_up": "Seguimiento",
    "leads.label.assign_to": "Asignar a",
    "leads.label.elevate_prospect": "Elevar prospecto",
    "leads.label.generate_quotation": "Generar cotización",
    "leads.label.convert_to_customer": "Convertir a cliente",
    "leads.label.edit": "Editar",
    "leads.label.history_data": "Datos de historial",
    "leads.label.call_status": "Estado de llamada",
    "leads.label.next_call": "Siguiente Llamada",
    "leads.label.quotations": "Cotizaciones",
    "leads.label.quote_id": "ID de Cotización",
    "leads.label.quote_number": "Número de Cotización",
    "leads.label.lead_id": "ID de Prospecto",
    "leads.label.total_charge": "Carga Total",
    "leads.label.generate_quote": "Generar cotización",
    "leads.label.delete_service_plan": "¿Eliminar plan de servicio?",
    "leads.label.personal_details": "Detalles personales",
    "leads.label.quote_status": "Estado de la cotización",
    "leads.label.quote_date": "Fecha de la cotización",
    "leads.label.customer_id": "ID de cliente",
    "leads.label.customer_name": "Nombre del cliente",
    "leads.label.plan": "Plan",
    "leads.label.frequency": "Frecuencia",
    "leads.label.recurring_charge": "Carga recurrente",
    "leads.label.one_time_charge": "Cargo único",
    "leads.label.add": "Agregar",
    "leads.label.service_code": "Código de servicio",
    "leads.label.exists_service_plans": "Planes de servicio existentes",
    "leads.label.plan_name": "Nombre del plan",
    "leads.label.reset": "Restablecer",
    "leads.label.edit_quote": "Editar Cotización",
    "leads.label.cancel_lead": "Cancelar Prospecto",
    "leads.label.status_remark": "Comentario de Estado",
    "leads.label.delete": "Eliminar",
    "leads.label.quote_details": "Detalles de la cotización",
    "leads.label.quotation_date": "Fecha de la cotización",
    "leads.label.quotation": "Cotización",
    "leads.label.price": "Precio",
    "leads.label.product": "Producto",
    "leads.label.charge_type": "Tipo de cargo",
    "leads.label.rate_uom": "Tarifa/UOM",
    "leads.label.download": "Descargar",
    "leads.label.service_plan": "Plan de servicio",
    "leads.label.ADDRESSDETAILS": "DETALLES DE DIRECCIÓN",
    "leads.label.Individual": "Individual",
    "leads.label.Corporate": "Corporativo",
    "leads.label.Type": "Tipo",
    "leads.label.EditLead": "Editar Cliente Potencial",
  },
  pt: {
    "leads.label.leads": "Leads",
    "leads.label.user": "Usuário",
    "leads.label.email_id": "Identificação de e-mail",
    "leads.label.address": "Endereço",
    "leads.label.phone_number": "Número de telefone",
    "leads.label.user": "Usuário",
    "leads.label.name": "Nome",
    "leads.label.remark": "Observação",
    "leads.label.status": "Status",
    "leads.label.action": "Ação",
    "leads.label.new_lead": "Novo Lead",
    "leads.label.close_leads": "Fechar Leads",
    "leads.label.status_remark": "Observação de status",
    "leads.label.cancel": "Cancelar",
    "leads.label.save": "Salvar",
    "leads.label.confirm": "Confirmar",
    "leads.label.createticket": "Criar Ticket",
    "leads.label.totalrecords": "Total de Registros",
    "leads.label.uploadprocess": "Processo de Upload",
    "leads.label.uploadfilepath": "Caminho do Arquivo de Upload",
    "leads.label.processingdate": "Data de Processamento",
    "leads.label.follow_up": "Acompanhamento",
    "leads.label.call_status": "Status da Chamada",
    "leads.label.next_call_date_time": "Próxima Data e Hora da Chamada",
    "leads.label.assigned_to": "Atribuído a",
    "leads.label.note": "Observação",
    "leads.label.create_lead": "Criar Lead",
    "leads.label.personal_details": "Detalhes Pessoais",
    "leads.label.BusinessEntityCode": "Código da Entidade Comercial",
    "leads.label.first_name": "Primeiro Nome",
    "leads.label.middle_name": "Nome do Meio",
    "leads.label.last_name": "Sobrenome",
    "leads.label.mobile_number": "Número de telemóvel",
    "leads.label.office_number": "Número do escritório",
    "leads.label.next": "Próximo",
    "leads.label.address_details": "Detalhes do endereço",
    "leads.label.city_area": "Cidade/Área",
    "leads.label.street_area": "Rua/Área",
    "leads.label.state": "Estado",
    "leads.label.country": "País",
    "leads.label.zip_code": "Código Postal",
    "leads.label.source_details": "Detalhes da Fonte",
    "leads.label.source": "Fonte",
    "leads.label.service": "Serviço",
    "leads.label.next_call_date_time": "Próxima Data e Hora da Chamada",
    "leads.label.complete": "Completo",
    "leads.label.submit": "Enviar",
    "leads.label.previous": "Anterior",
    "leads.label.done": "Concluído",
    "leads.label.personal_details": "DETALHES PESSOAIS",
    "leads.label.address_details": "DETALHES DO ENDEREÇO",
    "leads.label.source_details": "DETALHES DA FONTE",
    "leads.label.go_back_to_leads_list": "Voltar para a lista de leads",
    "leads.label.district": "Distrito",
    "leads.label.leads_details": "Detalhes dos leads",
    "leads.label.customer_view": "Visualização do cliente",
    "leads.label.follow_up": "Acompanhamento",
    "leads.label.assign_to": "Atribuir a",
    "leads.label.elevate_prospect": "Elevar Prospecto",
    "leads.label.generate_quotation": "Gerar Cotação",
    "leads.label.convert_to_customer": "Converter para Cliente",
    "leads.label.edit": "Editar",
    "leads.label.history_data": "Dados de histórico",
    "leads.label.call_status": "Estado da Chamada",
    "leads.label.next_call": "Próxima Chamada",
    "leads.label.quotations": "Cotações",
    "leads.label.quote_id": "ID da Cotação",
    "leads.label.quote_number": "Número da Cotação",
    "leads.label.lead_id": "ID do Lead",
    "leads.label.total_charge": "Carga Total",
    "leads.label.generate_quote": "Gerar Cotação",
    "leads.label.delete_service_plan": "Excluir plano de serviço?",
    "leads.label.personal_details": "Detalhes Pessoais",
    "leads.label.quote_status": "Status da Cotação",
    "leads.label.quote_date": "Data da Cotação",
    "leads.label.customer_id": "ID do Cliente",
    "leads.label.customer_name": "Nome do Cliente",
    "leads.label.plan": "Plano",
    "leads.label.frequency": "Frequência",
    "leads.label.recurring_charge": "Carga Recorrente",
    "leads.label.one_time_charge": "Carga Única",
    "leads.label.add": "Adicionar",
    "leads.label.service_code": "Código de Serviço",
    "leads.label.exists_service_plans": "Planos de serviço existentes",
    "leads.label.plan_name": "Nome do Plano",
    "leads.label.reset": "Redefinir",
    "leads.label.edit_quote": "Editar Cotação",
    "leads.label.cancel_lead": "Cancelar Lead",
    "leads.label.status_remark": "Observação de Status",
    "leads.label.delete": "Excluir",
    "leads.label.quote_details": "Detalhes da cotação",
    "leads.label.quotation_date": "Data da cotação",
    "leads.label.quotation": "Cotação",
    "leads.label.price": "Preço",
    "leads.label.product": "Produto",
    "leads.label.charge_type": "Tipo de cobrança",
    "leads.label.rate_uom": "Taxa/UOM",
    "leads.label.download": "Baixar",
    "leads.label.service_plan": "Plano de serviço",
    "leads.label.ADDRESSDETAILS": "DETALHES DO ENDEREÇO",
    "leads.label.Individual": "Individual",
    "leads.label.Corporate": "Corporativo",
    "leads.label.Type": "Tipo",
    "leads.label.EditLead": "Editar Lead",
  },
  zh_CN: {
    "leads.label.leads": "线索",
    "leads.label.user": "用户",
    "leads.label.email_id": "电子邮件地址",
    "leads.label.address": "地址",
    "leads.label.phone_number": "电话号码",
    "leads.label.user": "用户",
    "leads.label.name": "名称",
    "leads.label.remark": "备注",
    "leads.label.status": "状态",
    "leads.label.action": "行动",
    "leads.label.new_lead": "新线索",
    "leads.label.close_leads": "关闭线索",
    "leads.label.status_remark": "状态备注",
    "leads.label.cancel": "取消",
    "leads.label.save": "保存",
    "leads.label.confirm": "确认",
    "leads.label.createticket": "创建票据",
    "leads.label.totalrecords": "总记录数",
    "leads.label.uploadprocess": "上传过程",
    "leads.label.uploadfilepath": "上传文件路径",
    "leads.label.processingdate": "处理日期",
    "leads.label.follow_up": "跟进",
    "leads.label.call_status": "通话状态",
    "leads.label.next_call_date_time": "下次通话日期和时间",
    "leads.label.assigned_to": "分配给",
    "leads.label.note": "备注",
    "leads.label.create_lead": "创建线索",
    "leads.label.personal_details": "个人详情",
    "leads.label.BusinessEntityCode": "业务实体代码",
    "leads.label.first_name": "名字",
    "leads.label.middle_name": "中间名",
    "leads.label.last_name": "姓氏",
    "leads.label.mobile_number": "手機號碼",
    "leads.label.office_number": "办公电话",
    "leads.label.next": "下一个",
    "leads.label.address_details": "地址详情",
    "leads.label.city_area": "城市/地区",
    "leads.label.street_area": "街道/地区",
    "leads.label.state": "州",
    "leads.label.country": "国家",
    "leads.label.zip_code": "邮政编码",
    "leads.label.source_details": "来源详情",
    "leads.label.source": "来源",
    "leads.label.service": "服务",
    "leads.label.next_call_date_time": "下次通话日期和时间",
    "leads.label.complete": "完成",
    "leads.label.submit": "提交",
    "leads.label.previous": "上一页",
    "leads.label.done": "完成",
    "leads.label.personal_details": "个人详情",
    "leads.label.address_details": "地址详情",
    "leads.label.source_details": "来源详情",
    "leads.label.go_back_to_leads_list": "返回到线索列表",
    "leads.label.district": "地区",
    "leads.label.leads_details": "潜在客户详情",
    "leads.label.customer_view": "客户视图",
    "leads.label.follow_up": "跟进",
    "leads.label.assign_to": "分配给",
    "leads.label.elevate_prospect": "提升潜在客户",
    "leads.label.generate_quotation": "生成报价",
    "leads.label.convert_to_customer": "转换为客户",
    "leads.label.edit": "编辑",
    "leads.label.history_data": "历史数据",
    "leads.label.call_status": "通话状态",
    "leads.label.next_call": "下次通话",
    "leads.label.quotations": "报价",
    "leads.label.quote_id": "报价编号",
    "leads.label.quote_number": "报价号码",
    "leads.label.lead_id": "线索编号",
    "leads.label.total_charge": "总费用",
    "leads.label.generate_quote": "生成报价",
    "leads.label.delete_service_plan": "刪除服務計劃?",
    "leads.label.personal_details": "个人详情",
    "leads.label.quote_status": "报价状态",
    "leads.label.quote_date": "报价日期",
    "leads.label.customer_id": "客户编号",
    "leads.label.customer_name": "客户名称",
    "leads.label.plan": "计划",
    "leads.label.frequency": "频率",
    "leads.label.recurring_charge": "重复收费",
    "leads.label.one_time_charge": "一次性收费",
    "leads.label.add": "添加",
    "leads.label.service_code": "服务代码",
    "leads.label.exists_service_plans": "现有服务计划",
    "leads.label.plan_name": "计划名称",
    "leads.label.reset": "重置",
    "leads.label.edit_quote": "编辑报价",
    "leads.label.cancel_lead": "取消线索",
    "leads.label.status_remark": "状态备注",
    "leads.label.delete": "删除",
    "leads.label.quote_details": "报价详情",
    "leads.label.quotation_date": "报价日期",
    "leads.label.quotation": "报价",
    "leads.label.price": "价格",
    "leads.label.product": "产品",
    "leads.label.charge_type": "收费类型",
    "leads.label.rate_uom": "费率/单位",
    "leads.label.download": "下载",
    "leads.label.service_plan": "服务计划",
    "leads.label.ADDRESSDETAILS": "地址详情",
    "leads.label.Individual": "个人",
    "leads.label.Corporate": "公司",
    "leads.label.Type": "类型",
    "leads.label.EditLead": "编辑潜在客户",
  },
  hi: {
    "leads.label.leads": "लीड्स",
    "leads.label.user": "उपयोगकर्ता",
    "leads.label.email_id": "ईमेल आईडी",
    "leads.label.address": "पता",
    "leads.label.phone_number": "फोन नंबर",
    "leads.label.user": "उपयोगकर्ता",
    "leads.label.name": "नाम",
    "leads.label.remark": "टिप्पणी",
    "leads.label.status": "स्थिति",
    "leads.label.action": "कार्रवाई",
    "leads.label.new_lead": "नया लीड",
    "leads.label.close_leads": "लीड्स बंद करें",
    "leads.label.status_remark": "स्थिति टिप्पणी",
    "leads.label.cancel": "रद्द करें",
    "leads.label.save": "सहेजें",
    "leads.label.confirm": "पुष्टि करें",
    "leads.label.createticket": "टिकट बनाएं",
    "leads.label.totalrecords": "कुल रिकॉर्ड",
    "leads.label.uploadprocess": "अपलोड प्रक्रिया",
    "leads.label.uploadfilepath": "अपलोड फ़ाइल पथ",
    "leads.label.processingdate": "प्रोसेसिंग तिथि",
    "leads.label.follow_up": "फॉलो अप",
    "leads.label.call_status": "कॉल स्थिति",
    "leads.label.next_call_date_time": "अगली कॉल की तारीख और समय",
    "leads.label.assigned_to": "सौंपा गया",
    "leads.label.note": "टिप्पणी",
    "leads.label.create_lead": "लीड बनाएं",
    "leads.label.personal_details": "व्यक्तिगत विवरण",
    "leads.label.BusinessEntityCode": "व्यवसाय इकाई कोड",
    "leads.label.first_name": "पहला नाम",
    "leads.label.middle_name": "मध्य नाम",
    "leads.label.last_name": "उपनाम",
    "leads.label.mobile_number": "मोबाइल नंबर",
    "leads.label.office_number": "कार्यालय नंबर",
    "leads.label.next": "अगला",
    "leads.label.address_details": "पता विवरण",
    "leads.label.city_area": "शहर/क्षेत्र",
    "leads.label.street_area": "सड़क/क्षेत्र",
    "leads.label.state": "राज्य",
    "leads.label.country": "देश",
    "leads.label.zip_code": "पिन कोड",
    "leads.label.source_details": "स्रोत विवरण",
    "leads.label.source": "स्रोत",
    "leads.label.service": "सेवा",
    "leads.label.next_call_date_time": "अगली कॉल की तारीख और समय",
    "leads.label.complete": "पूरा",
    "leads.label.submit": "प्रस्तुत",
    "leads.label.previous": "पिछला",
    "leads.label.done": "किया हुआ",
    "leads.label.personal_details": "व्यक्तिगत विवरण",
    "leads.label.address_details": "पता विवरण",
    "leads.label.source_details": "स्रोत विवरण",
    "leads.label.go_back_to_leads_list": "लीड्स सूची पर वापस जाएं",
    "leads.label.district": "जिला",
    "leads.label.leads_details": "प्रोस्पेक्ट विवरण",
    "leads.label.customer_view": "ग्राहक दृश्य",
    "leads.label.follow_up": "अनुसरण करें",
    "leads.label.assign_to": "सौंपें",
    "leads.label.elevate_prospect": "प्रॉस्पेक्ट को उच्चतम करें",
    "leads.label.generate_quotation": "कोटेशन उत्पन्न करें",
    "leads.label.convert_to_customer": "ग्राहक में परिवर्तित करें",
    "leads.label.edit": "संपादित करें",
    "leads.label.history_data": "इतिहास डेटा",
    "leads.label.call_status": "कॉल स्थिति",
    "leads.label.next_call": "अगला कॉल",
    "leads.label.quotations": "उद्धरण",
    "leads.label.quote_id": "उद्धरण आईडी",
    "leads.label.quote_number": "उद्धरण संख्या",
    "leads.label.lead_id": "लीड आईडी",
    "leads.label.total_charge": "कुल शुल्क",
    "leads.label.generate_quote": "कोट उत्पन्न करें",
    "leads.label.delete_service_plan": "सेवा योजना हटाएँ?",
    "leads.label.personal_details": "व्यक्तिगत विवरण",
    "leads.label.quote_status": "कोट स्थिति",
    "leads.label.quote_date": "कोट तिथि",
    "leads.label.customer_id": "ग्राहक आईडी",
    "leads.label.customer_name": "ग्राहक का नाम",
    "leads.label.plan": "योजना",
    "leads.label.frequency": "आवृत्ति",
    "leads.label.recurring_charge": "पुनरावर्ती शुल्क",
    "leads.label.one_time_charge": "एक बार का शुल्क",
    "leads.label.add": "जोड़ें",
    "leads.label.service_code": "सेवा कोड",
    "leads.label.exists_service_plans": "मौजूदा सेवा योजनाएँ",
    "leads.label.plan_name": "योजना का नाम",
    "leads.label.reset": "रीसेट",
    "leads.label.edit_quote": "उद्धरण संपादित करें",
    "leads.label.cancel_lead": "प्रोस्पेक्ट रद्द करें",
    "leads.label.status_remark": "स्थिति टिप्पणी",
    "leads.label.delete": "हटाएँ",
    "leads.label.quote_details": "उद्धरण विवरण",
    "leads.label.quotation_date": "उद्धरण दिनांक",
    "leads.label.quotation": "उद्धरण",
    "leads.label.price": "मूल्य",
    "leads.label.product": "उत्पाद",
    "leads.label.charge_type": "शुल्क प्रकार",
    "leads.label.rate_uom": "मूल्य/इकाई",
    "leads.label.download": "डाउनलोड",
    "leads.label.service_plan": "सेवा योजना",
    "leads.label.ADDRESSDETAILS": "पते का विवरण",
    "leads.label.Individual": "व्यक्तिगत",
    "leads.label.Corporate": "कॉर्पोरेट",
    "leads.label.Type": "प्रकार",
    "leads.label.EditLead": "लीड संपादित करें",
  },
  ka: {
    "leads.label.leads": "წარმოებული",
    "leads.label.user": "მომხმარებელი",
    "leads.label.email_id": "ელ. ფოსტა",
    "leads.label.address": "მისამართი",
    "leads.label.phone_number": "ტელეფონის ნომერი",
    "leads.label.user": "მომხმარებელი",
    "leads.label.name": "სახელი",
    "leads.label.remark": "შენიშვნა",
    "leads.label.status": "სტატუსი",
    "leads.label.action": "ქმედება",
    "leads.label.new_lead": "ახალი წარმოება",
    "leads.label.close_leads": "წარდგმა",
    "leads.label.status_remark": "სტატუსის შენიშვნა",
    "leads.label.cancel": "გაუქმება",
    "leads.label.save": "შენახვა",
    "leads.label.confirm": "დადასტურება",
    "leads.label.createticket": "ბილეთის შექმნა",
    "leads.label.totalrecords": "სრული ჩანაწერები",
    "leads.label.uploadprocess": "მიღების პროცესი",
    "leads.label.uploadfilepath": "ფაილის ჩატვირთვის მარშრუტი",
    "leads.label.processingdate": "პროცესირების თარიღი",
    "leads.label.follow_up": "მომავლის გამორჩევა",
    "leads.label.call_status": "გაურკვეველი სტატუსი",
    "leads.label.next_call_date_time": "შემდეგი ზარის თარიღი და დრო",
    "leads.label.assigned_to": "დანიშნული",
    "leads.label.note": "შინაარსი",
    "leads.label.create_lead": "წარმოება შექმნა",
    "leads.label.personal_details": "პირადი დეტალები",
    "leads.label.BusinessEntityCode": "ბიზნეს ერთეულის კოდი",
    "leads.label.first_name": "სახელი",
    "leads.label.middle_name": "მეორე სახელი",
    "leads.label.last_name": "გვარი",
    "leads.label.mobile_number": "Მობილურის ნომერი",
    "leads.label.office_number": "Სამუშაო ნომერი",
    "leads.label.next": "შემდეგი",
    "leads.label.address_details": "მისამართის დეტალები",
    "leads.label.city_area": "ქალაქი/უბანი",
    "leads.label.street_area": "ქუჩა/უბანი",
    "leads.label.state": "სახელმწიფო",
    "leads.label.country": "ქვეყანა",
    "leads.label.zip_code": "საფოსტო ინდექსი",
    "leads.label.source_details": "წყაროს დეტალები",
    "leads.label.source": "წყარო",
    "leads.label.service": "მომსახურება",
    "leads.label.next_call_date_time": "შემდეგი ზარის თარიღი და დრო",
    "leads.label.complete": "დასრულება",
    "leads.label.submit": "წარმოადგენს",
    "leads.label.previous": "წინა",
    "leads.label.done": "შესრულებული",
    "leads.label.personal_details": "პირადი დეტალები",
    "leads.label.address_details": "მისამართის დეტალები",
    "leads.label.source_details": "წყაროს დეტალები",
    "leads.label.go_back_to_leads_list": "დაბრუნება საწყისი ლისტზე",
    "leads.label.district": "რაიონი",
    "leads.label.leads_details": "პროსპექტის დეტალები",
    "leads.label.customer_view": "კლიენტის ხედი",
    "leads.label.follow_up": "შემდეგი",
    "leads.label.assign_to": "დანიშნულება",
    "leads.label.elevate_prospect": "პროსპექტის არასწორი მონაცემები",
    "leads.label.generate_quotation": "ფასების შექმნა",
    "leads.label.convert_to_customer": "კლიენტად გადართვა",
    "leads.label.edit": "რედაქტირება",
    "leads.label.history_data": "ისტორიული მონაცემები",
    "leads.label.call_status": "ზარის სტატუსი",
    "leads.label.next_call": "შემდეგი ზარი",
    "leads.label.quotations": "ფასები",
    "leads.label.quote_id": "ფასების იდენტიფიკატორი",
    "leads.label.quote_number": "ფასების ნომერი",
    "leads.label.lead_id": "ლიდის იდენტიფიკატორი",
    "leads.label.total_charge": "სულ დაგროვება",
    "leads.label.generate_quote": "ფასების შექმნა",
    "leads.label.delete_service_plan": "წაშალოთ სერვისის გეგმა?",
    "leads.label.personal_details": "პიროვნების დეტალები",
    "leads.label.quote_status": "ფასის სტატუსი",
    "leads.label.quote_date": "ფასის თარიღი",
    "leads.label.customer_id": "კლიენტის ID",
    "leads.label.customer_name": "კლიენტის სახელი",
    "leads.label.plan": "გეგმა",
    "leads.label.frequency": "ხაზგარეშე",
    "leads.label.recurring_charge": "გამავალი გადახდა",
    "leads.label.one_time_charge": "ერთჯერადი გადახდა",
    "leads.label.add": "დამატება",
    "leads.label.service_code": "სერვისის კოდი",
    "leads.label.exists_service_plans": "არსებული მომსახურების გეგმები",
    "leads.label.plan_name": "გეგმის სახელი",
    "leads.label.reset": "გადაყენება",
    "leads.label.edit_quote": "რედაქტირება",
    "leads.label.cancel_lead": "პროსპექტის გაუქმება",
    "leads.label.status_remark": "სტატუსის შენიშვნა",
    "leads.label.delete": "წაშლა",
    "leads.label.quote_details": "კოტირების დეტალები",
    "leads.label.quotation_date": "კოტირების თარიღი",
    "leads.label.quotation": "კოტირება",
    "leads.label.price": "ფასი",
    "leads.label.product": "პროდუქტი",
    "leads.label.charge_type": "დაკისრების ტიპი",
    "leads.label.rate_uom": "კურსი/UOM",
    "leads.label.download": "ჩამოტვირთვა",
    "leads.label.service_plan": "სერვისის გეგმა",
    "leads.label.ADDRESSDETAILS": "მისამართის დეტალები",
    "leads.label.Individual": "ფიზიკური პირი",
    "leads.label.Corporate": "კორპორატიული",
    "leads.label.Type": "ტიპი",
    "leads.label.EditLead": "წინამდებარე რედაქტირება",
  },
  lo: {
    "leads.label.leads": "ຜູ້ໃຊ້ລະບົບ",
    "leads.label.user": "ຜູ້ໃຊ້ງານ",
    "leads.label.email_id": "ອີເມວອີຟອມ",
    "leads.label.address": "ທີ່ຢູ່",
    "leads.label.phone_number": "ເບີໂທ",
    "leads.label.user": "ຜູ້ໃຊ້ງານ",
    "leads.label.name": "ຊື່",
    "leads.label.remark": "ຄຳແນະນຳ",
    "leads.label.status": "ສະຖານະ",
    "leads.label.action": "ການປະຕິບັດ",
    "leads.label.new_lead": "ຜູ້ອັບເດດໃໝ່",
    "leads.label.close_leads": "ປິດການປະຕິບັດ",
    "leads.label.status_remark": "ຄຳແນະນຳສະຖານະ",
    "leads.label.cancel": "ຍົກເລີກ",
    "leads.label.save": "ບັນທຶກ",
    "leads.label.confirm": "ຢືນຢັນ",
    "leads.label.createticket": "ສ້າງບັດ",
    "leads.label.totalrecords": "ລາຍການທັງໝົດ",
    "leads.label.uploadprocess": "ຂະບວນການອັບໂຫລດ",
    "leads.label.uploadfilepath": "ທາງສະແດງເອກະລີງອັບໂຫລດ",
    "leads.label.processingdate": "ວັນທີ່ປ່ອນງານ",
    "leads.label.follow_up": "ການປະຕິບັດຮຽນ",
    "leads.label.call_status": "ສະຖານະໂທ",
    "leads.label.next_call_date_time": "ວັນເລີ່ມຕົ້ນທີ່ມີເວລາຂອງໂທລະສັບ",
    "leads.label.assigned_to": "ມອບທັນ",
    "leads.label.note": "ໝາຍເຫດ",
    "leads.label.create_lead": "ສ້າງຜູ້ຮັບປະກັນ",
    "leads.label.personal_details": "ລາຍລະອຽດພະນັກງານ",
    "leads.label.BusinessEntityCode": "ລະຫັດໂຄງການທຸລະກິດ",
    "leads.label.first_name": "ຊື່",
    "leads.label.middle_name": "ຊື່ສຸດ",
    "leads.label.last_name": "ນາມສະກຸນ",
    "leads.label.mobile_number": "ເບີ​ໂທລະ​ສັບ",
    "leads.label.office_number": "ເບີໂທຫ້ອງເຮັດ",
    "leads.label.next": "ຕໍ່ໄປ",
    "leads.label.address_details": "ລາຍລະອຽດທີ່ຢູ່",
    "leads.label.city_area": "ເມືອງ/ເຂດ",
    "leads.label.street_area": "ທະບູລັດ/ເຂດ",
    "leads.label.state": "ລັດ",
    "leads.label.country": "ປະເທດ",
    "leads.label.zip_code": "ໂລກຫານໄປ",
    "leads.label.source_details": "ລາຍລະອຽດຕິດຕໍ່",
    "leads.label.source": "ຕິດຕໍ່",
    "leads.label.service": "ການບໍລິການ",
    "leads.label.next_call_date_time": "ວັນເລີ່ມຕົ້ນທີ່ມີເວລາຂອງໂທລະສັບ",
    "leads.label.complete": "ສົ່ງລົງ",
    "leads.label.submit": "ສົ່ງ",
    "leads.label.previous": "ກ່ອນ",
    "leads.label.done": "ເຮັດແລ້ວ",
    "leads.label.personal_details": "ລາຍລະອຽດພະນັກງານ",
    "leads.label.address_details": "ລາຍລະອຽດທີ່ຢູ່",
    "leads.label.source_details": "ລາຍລະອຽດຕິດຕໍ່",
    "leads.label.go_back_to_leads_list": "ກັບຄືນໄປຫາລາຍຊື່ຜູ້ໃຊ້",
    "leads.label.district": "ເມືອງ",
    "leads.label.leads_details": "ລາຍລະອຽດຜູ້ໃຊ້",
    "leads.label.customer_view": "ເບິ່ງລູກຄ້າ",
    "leads.label.follow_up": "ຕິດຕາມຕົວເລືອກ",
    "leads.label.assign_to": "ມອບໃຫ້",
    "leads.label.elevate_prospect": "ໂທລະສັບເຂົ້າຊົມຫຼືແຮງໂທ",
    "leads.label.generate_quotation": "ສ້າງລາຍລະອຽດ",
    "leads.label.convert_to_customer": "ປ່ຽນເປັນລູກຄ້າ",
    "leads.label.edit": "ແກ້ໄຂ",
    "leads.label.history_data": "ຂໍ້ມູນປະຫວັດ",
    "leads.label.call_status": "ສະຖານະໂທລະສັບ",
    "leads.label.next_call": "ປະຊາກອນຖັນ",
    "leads.label.quotations": "ຄໍາອະທິບາຍ",
    "leads.label.quote_id": "ລະຫັດອະທິບາຍ",
    "leads.label.quote_number": "ເລກອະທິບາຍ",
    "leads.label.lead_id": "ລະຫັດຜູ້ໃຊ້",
    "leads.label.total_charge": "ຄ່າຄົງເຫຼືອອື່ນ",
    "leads.label.generate_quote": "ສ້າງລາຍການ",
    "leads.label.delete_service_plan": "ລຶບແຜນການບໍລິການບໍ?",
    "leads.label.personal_details": "ລາຍລະອຽດສໍາລັບບຸກຄົນ",
    "leads.label.quote_status": "ສະຖານະຂອງລາຍການ",
    "leads.label.quote_date": "ວັນທີ່ສ້າງລາຍການ",
    "leads.label.customer_id": "ລະຫັດລູກຄ້າ",
    "leads.label.customer_name": "ຊື່ລູກຄ້າ",
    "leads.label.plan": "ໂປຣແກຣມ",
    "leads.label.frequency": "ຈຳນວນ",
    "leads.label.recurring_charge": "ຄ່າໂທລະສັບ",
    "leads.label.one_time_charge": "ຄ່າໂທລະສັບຄ່າເຕັມ",
    "leads.label.add": "ເພີ່ມ",
    "leads.label.service_code": "ລະຫັດບໍລິການ",
    "leads.label.exists_service_plans": "ມີປະກາດຂອງການປົດໄລນາຄົນ",
    "leads.label.plan_name": "ຊື່ການຈັດການ",
    "leads.label.reset": "ລຸບ",
    "leads.label.edit_quote": "ແກ້ໄຂເນື້ອຫາ",
    "leads.label.cancel_lead": "ຍົກເລີກຜູ້ເຊື້ອມິ່ນ",
    "leads.label.status_remark": "ຄຳເຫັນສະຖານະ",
    "leads.label.delete": "ລຶບ",
    "leads.label.quote_details": "ລາຍລະອຽດຂໍ້ມູນອະນຸມັດ",
    "leads.label.quotation_date": "ວັນທີ່ລາຍການອະນຸມັດ",
    "leads.label.quotation": "ລາຍການອະນຸມັດ",
    "leads.label.price": "ລາຄາ",
    "leads.label.product": "ຜະລິດຕະພັນ",
    "leads.label.charge_type": "ປະເພດຄ່າເສຍ",
    "leads.label.rate_uom": "ອັດຕາ/UOM",
    "leads.label.download": "ດາວໂຫລດ",
    "leads.label.service_plan": "ໂປຣໂມຊັ້ນການບໍລິການ",
    "leads.label.ADDRESSDETAILS": "ລາຍລະອຽດທີ່ຢູ່",
    "leads.label.Individual": "ບຸກຄົນ",
    "leads.label.Corporate": "ບໍລິສັດ",
    "leads.label.Type": "ປະເພດ",
    "leads.label.EditLead": "ແກ້ໄຂລາຍຊື່",
  },
  vi: {
    "leads.label.leads": "Cơ hội",
    "leads.label.user": "Người dùng",
    "leads.label.email_id": "Địa chỉ Email",
    "leads.label.address": "Địa chỉ",
    "leads.label.phone_number": "Số điện thoại",
    "leads.label.user": "Người dùng",
    "leads.label.name": "Tên",
    "leads.label.remark": "Ghi chú",
    "leads.label.status": "Trạng thái",
    "leads.label.action": "Hành động",
    "leads.label.new_lead": "Cơ hội mới",
    "leads.label.close_leads": "Đóng Cơ hội",
    "leads.label.status_remark": "Ghi chú Trạng thái",
    "leads.label.cancel": "Hủy",
    "leads.label.save": "Lưu",
    "leads.label.confirm": "Xác nhận",
    "leads.label.createticket": "Tạo Phiếu",
    "leads.label.totalrecords": "Tổng Số Ghi Chép",
    "leads.label.uploadprocess": "Quá Trình Tải Lên",
    "leads.label.uploadfilepath": "Đường Dẫn Tập Tin Tải Lên",
    "leads.label.processingdate": "Ngày Xử Lý",
    "leads.label.follow_up": "Theo dõi",
    "leads.label.call_status": "Trạng thái cuộc gọi",
    "leads.label.next_call_date_time": "Ngày giờ gọi tiếp theo",
    "leads.label.assigned_to": "Phân công cho",
    "leads.label.note": "Ghi chú",
    "leads.label.create_lead": "Tạo Cơ hội",
    "leads.label.personal_details": "Chi tiết Cá nhân",
    "leads.label.BusinessEntityCode": "Mã Thực Thể Kinh Doanh",
    "leads.label.first_name": "Tên",
    "leads.label.middle_name": "Tên đệm",
    "leads.label.last_name": "Họ",
    "leads.label.mobile_number": "Số điện thoại",
    "leads.label.office_number": "Số văn phòng",
    "leads.label.next": "Kế tiếp",
    "leads.label.address_details": "Chi tiết địa chỉ",
    "leads.label.city_area": "Thành phố/Khu vực",
    "leads.label.street_area": "Đường/Khu vực",
    "leads.label.state": "Tiểu bang",
    "leads.label.country": "Quốc gia",
    "leads.label.zip_code": "Mã bưu điện",
    "leads.label.source_details": "Chi tiết Nguồn",
    "leads.label.source": "Nguồn",
    "leads.label.service": "Dịch vụ",
    "leads.label.next_call_date_time": "Ngày giờ gọi tiếp theo",
    "leads.label.complete": "Hoàn tất",
    "leads.label.submit": "Gửi",
    "leads.label.previous": "Trước",
    "leads.label.done": "Hoàn tất",
    "leads.label.personal_details": "CHI TIẾT CÁ NHÂN",
    "leads.label.address_details": "CHI TIẾT ĐỊA CHỈ",
    "leads.label.source_details": "CHI TIẾT NGUỒN",
    "leads.label.go_back_to_leads_list": "Quay lại danh sách Leads",
    "leads.label.district": "Quận",
    "leads.label.leads_details": "Chi tiết Lead",
    "leads.label.customer_view": "Xem Khách hàng",
    "leads.label.follow_up": "Theo dõi",
    "leads.label.assign_to": "Phân công cho",
    "leads.label.elevate_prospect": "Nâng cấp Tiềm năng",
    "leads.label.generate_quotation": "Tạo Báo giá",
    "leads.label.convert_to_customer": "Chuyển đổi thành Khách hàng",
    "leads.label.edit": "Chỉnh sửa",
    "leads.label.history_data": "Dữ liệu lịch sử",
    "leads.label.call_status": "Trạng thái cuộc gọi",
    "leads.label.next_call": "Cuộc gọi tiếp theo",
    "leads.label.quotations": "Bảng báo giá",
    "leads.label.quote_id": "ID Báo giá",
    "leads.label.quote_number": "Số Báo giá",
    "leads.label.lead_id": "ID Cơ hội",
    "leads.label.total_charge": "Tổng chi phí",
    "leads.label.generate_quote": "Tạo Báo giá",
    "leads.label.delete_service_plan": "Xóa gói dịch vụ?",
    "leads.label.personal_details": "Chi tiết Cá nhân",
    "leads.label.quote_status": "Trạng thái Báo giá",
    "leads.label.quote_date": "Ngày Báo giá",
    "leads.label.customer_id": "ID Khách hàng",
    "leads.label.customer_name": "Tên Khách hàng",
    "leads.label.plan": "Kế hoạch",
    "leads.label.frequency": "Tần suất",
    "leads.label.recurring_charge": "Phí định kỳ",
    "leads.label.one_time_charge": "Phí một lần",
    "leads.label.add": "Thêm",
    "leads.label.service_code": "Mã Dịch vụ",
    "leads.label.exists_service_plans": "Kế hoạch Dịch vụ Hiện có",
    "leads.label.plan_name": "Tên Kế hoạch",
    "leads.label.reset": "Đặt lại",
    "leads.label.edit_quote": "Chỉnh sửa Báo giá",
    "leads.label.cancel_lead": "Hủy Cơ hội",
    "leads.label.status_remark": "Ghi chú Trạng thái",
    "leads.label.delete": "Xóa",
    "leads.label.quote_details": "Chi tiết Báo giá",
    "leads.label.quotation_date": "Ngày Báo giá",
    "leads.label.quotation": "Báo giá",
    "leads.label.price": "Giá",
    "leads.label.product": "Sản phẩm",
    "leads.label.charge_type": "Loại phí",
    "leads.label.rate_uom": "Tỷ lệ/UOM",
    "leads.label.download": "Tải xuống",
    "leads.label.service_plan": "Kế hoạch dịch vụ",
    "leads.label.ADDRESSDETAILS": "CHI TIẾT ĐỊA CHỈ",
    "leads.label.Individual": "Cá Nhân",
    "leads.label.Corporate": "Tập Đoàn",
    "leads.label.Type": "Loại",
    "leads.label.EditLead": "Chỉnh Sửa Khách Hàng Tiềm Năng",
  },
  my_MM: {
    "leads.label.leads": "အိုင်ဒီယို",
    "leads.label.user": "အသုံးပြုသူ",
    "leads.label.email_id": "အီးမေးလ်လိပ်စာ",
    "leads.label.address": "လိပ်စာ",
    "leads.label.phone_number": "ဖုန်းနံပါတ်",
    "leads.label.user": "အသုံးပြုသူ",
    "leads.label.name": "နာမည်",
    "leads.label.remark": "မှတ်ချက်",
    "leads.label.status": "အခြေအနေ",
    "leads.label.action": "လုပ်ဆောင်ချက်",
    "leads.label.new_lead": "အသစ်လုပ်ငန်း",
    "leads.label.close_leads": "အိုင်ဒီယို ပိတ်ထားသည်",
    "leads.label.status_remark": "အခြေအနေမှတ်ချက်",
    "leads.label.cancel": "ပယ်ဖျက်သည်",
    "leads.label.save": "သိမ်းဆည်းသည်",
    "leads.label.confirm": "အတည်ပြုသည်",
    "leads.label.createticket": "လက်မှတ်ထုတ်မည်",
    "leads.label.totalrecords": "စုစုပေါင်းမှတ်တမ်းများ",
    "leads.label.uploadprocess": "အပ်လုံးလုပ်ငန်းစဉ်",
    "leads.label.uploadfilepath": "အပ်လုံးဖိုင်လမ်းကြောင်း",
    "leads.label.processingdate": "လုပ်ငန်းစဉ်ရက်စွဲ",
    "leads.label.follow_up": "ရရှိသည်",
    "leads.label.call_status": "ဖုန်းဆက်သစ်အခြေအနေ",
    "leads.label.next_call_date_time": "နောက်ဆုံးဖုန်းဆက်မှုရက်နေ့နှင့်အချိန်",
    "leads.label.assigned_to": "တွဲဖက်",
    "leads.label.note": "မှတ်ချက်",
    "leads.label.create_lead": "လီဒါ ဖန်တီးရန်",
    "leads.label.personal_details": "ကိုယ်ရေး အသုံးပြုသူ အသေးစိတ်",
    "leads.label.BusinessEntityCode": "စီးပွားရေးအဖွဲ့အစည်းကုဒ်",
    "leads.label.first_name": "အသုံးပြုသူအမည်",
    "leads.label.middle_name": "အဆင့်နာမည်",
    "leads.label.last_name": "မျိုးနွယ်",
    "leads.label.mobile_number": "မိုဘိုင်းနံပါတ်",
    "leads.label.office_number": "ရုံးအုပ်စု",
    "leads.label.next": "နောက်",
    "leads.label.address_details": "လိပ်စာအသေးစိတ်",
    "leads.label.city_area": "မြို့/ဧရိယာ",
    "leads.label.street_area": "လမ်း/ဧရိယာ",
    "leads.label.state": "ပြည်နယ်",
    "leads.label.country": "နိုင်ငံ",
    "leads.label.zip_code": "စာတိုက်နံပါတ်",
    "leads.label.source_details": "ရင်းမြတ်သောအသိပေးချက်များ",
    "leads.label.source": "ရင်းမြတ်",
    "leads.label.service": "ဝန်ဆောင်မှု",
    "leads.label.next_call_date_time": "နောက်ဆုံးဖုန်းဆက်ချိန်နှင့်အချိန်",
    "leads.label.complete": "အပြီးစီး",
    "leads.label.submit": "တင်သွင်းပါ",
    "leads.label.previous": "နောက်သို့",
    "leads.label.done": "ပြီးပြည့်စုံး",
    "leads.label.personal_details": "ကိုယ်ရေး အသုံးပြုသူ အသေးစိတ်",
    "leads.label.address_details": "လိပ်စာအသေးစိတ်",
    "leads.label.source_details": "ရင်းမြတ်သောအသိပေးချက်များ",
    "leads.label.go_back_to_leads_list":
      "လီဒါနှင့်ပတ်သက်သည့်စာရင်းသို့ ပြန်လာပါ",
    "leads.label.district": "ခရိုင်",
    "leads.label.leads_details": "လီဒါနှင့်အသေးစိတ်",
    "leads.label.customer_view": "ဝန်ထမ်းကျင်ကြေး",
    "leads.label.follow_up": "နောက်ဆုံး",
    "leads.label.assign_to": "တည်နေရာထားရန်",
    "leads.label.elevate_prospect": "နောက်ဆုံးပါးသောပရိုမိုးကြေးများ",
    "leads.label.generate_quotation": "အမှာစာအသစ်လုပ်ဆောင်ခြင်း",
    "leads.label.convert_to_customer": "ဝန်ထမ်းသိမ်းခြင်း",
    "leads.label.edit": "ပြင်ဆင်မည်",
    "leads.label.history_data": "သမိုင်းတော်အချက်အလက်",
    "leads.label.call_status": "ဖုန်းဆက်နံပါတ်အခြေအနေ",
    "leads.label.next_call": "နောက်ဆုံးဖုန်းဆက်",
    "leads.label.quotations": "စာရင်းနှင့်မီးဖြိုးများ",
    "leads.label.quote_id": "မီးဖြိုးနံပါတ်",
    "leads.label.quote_number": "မီးဖြိုးနံပါတ်",
    "leads.label.lead_id": "လီဒါနှင့်အခြေအနေ",
    "leads.label.total_charge": "ကျသင့်ငွေစုစုပေါင်း",
    "leads.label.generate_quote": "မီးဖြိုးဆန်းစစ်ရန်",
    "leads.label.delete_service_plan": "ဝန်ဆောင်မှုအစီအစဉ်ကို ဖျက်မလား။",
    "leads.label.personal_details": "ကိုယ်ရေးအချက်အလက်",
    "leads.label.quote_status": "မီးဖြိုးအခြေအနေ",
    "leads.label.quote_date": "မီးဖြိုးရက်",
    "leads.label.customer_id": "သုံးစွဲသူအမှတ်စဥ်",
    "leads.label.customer_name": "သုံးစွဲသူအမည်",
    "leads.label.plan": "ပစ္စည်း",
    "leads.label.frequency": "စနစ်",
    "leads.label.recurring_charge": "ထပ်မံပေးချေမှု",
    "leads.label.one_time_charge": "တစ်ခုခြင်းပေးချေမှု",
    "leads.label.add": "ထည့်ပါ",
    "leads.label.service_code": "ဝန်ဆောင်မှုကုဒ်",
    "leads.label.exists_service_plans": "ရှိသောဝန်ဆောင်မှုပစ္စည်းများ",
    "leads.label.plan_name": "မီးချင်းနာမည်",
    "leads.label.reset": "ပြန်စမည်",
    "leads.label.edit_quote": "အမှတ်အသားဖြင့်သတ်မှတ်မည်",
    "leads.label.cancel_lead": "လီဒါနှင့်ဖျက်ရန်",
    "leads.label.status_remark": "အခြေအနေအကြောင်းအရာ",
    "leads.label.delete": "ဖျက်မည်",
    "leads.label.quote_details": "အမှတ်အသားဖြင့်အသေးစိတ်",
    "leads.label.quotation_date": "အမှတ်အသားပေးသွင်းသည့်နေ့စွဲ",
    "leads.label.quotation": "အမှတ်အသားပေးသွင်းသည့်နေ့စွဲ",
    "leads.label.price": "စျေးနှုန်း",
    "leads.label.product": "လက်ကျန်ပစ္စည်း",
    "leads.label.charge_type": "ငွေသေးငွေပမာဏ",
    "leads.label.rate_uom": "ငွေမတန်း/UOM",
    "leads.label.download": "ဒေါင်းလုတ်",
    "leads.label.service_plan": "ဝန်ဆောင်မှုအစီအစဉ်",
    "leads.label.ADDRESSDETAILS": "လိပ်စာအသေးစိတ်",
    "leads.label.Individual": "ပုဂ္ဂလိက",
    "leads.label.Corporate": "ကုမ္ပဏီ",
    "leads.label.Type": "အမျိုးအစား",
    "leads.label.EditLead": "ခေါင်းဆောင်ကို တည်းဖြတ်",
  },
  my: {
    "leads.label.leads": "အိုင်ဒီယို",
    "leads.label.user": "အသုံးပြုသူ",
    "leads.label.email_id": "အီးမေးလ်လိပ်စာ",
    "leads.label.address": "လိပ်စာ",
    "leads.label.phone_number": "ဖုန်းနံပါတ်",
    "leads.label.user": "အသုံးပြုသူ",
    "leads.label.name": "နာမည်",
    "leads.label.remark": "မှတ်ချက်",
    "leads.label.status": "အခြေအနေ",
    "leads.label.action": "လုပ်ဆောင်ချက်",
    "leads.label.new_lead": "အသစ်လုပ်ငန်း",
    "leads.label.close_leads": "အိုင်ဒီယို ပိတ်ထားသည်",
    "leads.label.status_remark": "အခြေအနေမှတ်ချက်",
    "leads.label.cancel": "ပယ်ဖျက်သည်",
    "leads.label.save": "သိမ်းဆည်းသည်",
    "leads.label.confirm": "အတည်ပြုသည်",
    "leads.label.createticket": "တက်ကတ်ဖန်တီးမည်",
    "leads.label.totalrecords": "စုစုပေါင်းမှတ်တမ်းများ",
    "leads.label.uploadprocess": "အပ်လုံးလုပ်ငန်းစဉ်",
    "leads.label.uploadfilepath": "အပ်လုံးဖိုင်လမ်းကြောင်း",
    "leads.label.processingdate": "လုပ်ငန်းစဉ်ရက်စွဲ",
    "leads.label.follow_up": "ရရှိသည်",
    "leads.label.call_status": "ဖုန်းဆက်သစ်အခြေအနေ",
    "leads.label.next_call_date_time": "နောက်ဆုံးဖုန်းဆက်မှုရက်နေ့နှင့်အချိန်",
    "leads.label.assigned_to": "တွဲဖက်",
    "leads.label.note": "မှတ်ချက်",
    "leads.label.create_lead": "လီဒါ ဖန်တီးရန်",
    "leads.label.personal_details": "ကိုယ်ရေး အသုံးပြုသူ အသေးစိတ်",
    "leads.label.BusinessEntityCode": "စီးပွားရေးအဖွဲ့အစည်းကုဒ်",
    "leads.label.first_name": "အသုံးပြုသူအမည်",
    "leads.label.middle_name": "အဆင့်နာမည်",
    "leads.label.last_name": "မျိုးနွယ်",
    "leads.label.mobile_number": "မိုဘိုင်းနံပါတ်",
    "leads.label.office_number": "ရုံးအုပ်စု",
    "leads.label.next": "နောက်",
    "leads.label.address_details": "လိပ်စာအသေးစိတ်",
    "leads.label.city_area": "မြို့/ဧရိယာ",
    "leads.label.street_area": "လမ်း/ဧရိယာ",
    "leads.label.state": "ပြည်နယ်",
    "leads.label.country": "နိုင်ငံ",
    "leads.label.zip_code": "စာတိုက်နံပါတ်",
    "leads.label.source_details": "ရင်းမြတ်သောအသိပေးချက်များ",
    "leads.label.source": "ရင်းမြတ်",
    "leads.label.service": "ဝန်ဆောင်မှု",
    "leads.label.next_call_date_time": "နောက်ဆုံးဖုန်းဆက်ချိန်နှင့်အချိန်",
    "leads.label.complete": "အပြီးစီး",
    "leads.label.submit": "တင်သွင်းပါ",
    "leads.label.previous": "နောက်သို့",
    "leads.label.done": "ပြီးပြည့်စုံး",
    "leads.label.personal_details": "ကိုယ်ရေး အသုံးပြုသူ အသေးစိတ်",
    "leads.label.address_details": "လိပ်စာအသေးစိတ်",
    "leads.label.source_details": "ရင်းမြတ်သောအသိပေးချက်များ",
    "leads.label.go_back_to_leads_list":
      "လီဒါနှင့်ပတ်သက်သည့်စာရင်းသို့ ပြန်လာပါ",
    "leads.label.district": "ခရိုင်",
    "leads.label.leads_details": "လီဒါနှင့်အသေးစိတ်",
    "leads.label.customer_view": "ဝန်ထမ်းကျင်ကြေး",
    "leads.label.follow_up": "နောက်ဆုံး",
    "leads.label.assign_to": "တည်နေရာထားရန်",
    "leads.label.elevate_prospect": "နောက်ဆုံးပရိုမိုးကြေးများ",
    "leads.label.generate_quotation": "အမှာစာအသစ်လုပ်ဆောင်ခြင်း",
    "leads.label.convert_to_customer": "ဝန်ထမ်းသိမ်းခြင်း",
    "leads.label.edit": "ပြင်ဆင်မည်",
    "leads.label.history_data": "သမိုင်းတော်အချက်အလက်",
    "leads.label.call_status": "ဖုန်းဆက်နံပါတ်အခြေအနေ",
    "leads.label.next_call": "နောက်ဆုံးဖုန်းဆက်",
    "leads.label.quotations": "စာရင်းနှင့်မီးဖြိုးများ",
    "leads.label.quote_id": "မီးဖြိုးနံပါတ်",
    "leads.label.quote_number": "မီးဖြိုးနံပါတ်",
    "leads.label.lead_id": "လီဒါနှင့်အခြေအနေ",
    "leads.label.total_charge": "ကျသင့်ငွေစုစုပေါင်း",
    "leads.label.generate_quote": "မီးဖြိုးဆန်းစစ်ရန်",
    "leads.label.delete_service_plan": "ဝန်ဆောင်မှုအစီအစဉ်ကို ဖျက်မလား။",
    "leads.label.personal_details": "ကိုယ်ရေးအချက်အလက်",
    "leads.label.quote_status": "မီးဖြိုးအခြေအနေ",
    "leads.label.quote_date": "မီးဖြိုးရက်",
    "leads.label.customer_id": "သုံးစွဲသူအမှတ်စဥ်",
    "leads.label.customer_name": "သုံးစွဲသူအမည်",
    "leads.label.plan": "ပစ္စည်း",
    "leads.label.frequency": "စနစ်",
    "leads.label.recurring_charge": "ထပ်မံပေးချေမှု",
    "leads.label.one_time_charge": "တစ်ခုခြင်းပေးချေမှု",
    "leads.label.add": "ထည့်ပါ",
    "leads.label.service_code": "ဝန်ဆောင်မှုကုဒ်",
    "leads.label.exists_service_plans": "ရှိသောဝန်ဆောင်မှုပစ္စည်းများ",
    "leads.label.plan_name": "မီးချင်းနာမည်",
    "leads.label.reset": "ပြန်စမည်",
    "leads.label.edit_quote": "အမှတ်အသားဖြင့်သတ်မှတ်မည်",
    "leads.label.cancel_lead": "လီဒါနှင့်ဖျက်ရန်",
    "leads.label.status_remark": "အခြေအနေအကြောင်းအရာ",
    "leads.label.delete": "ဖျက်မည်",
    "leads.label.quote_details": "အမှတ်အသားဖြင့်အသေးစိတ်",
    "leads.label.quotation_date": "အမှတ်အသားပေးသွင်းသည့်နေ့စွဲ",
    "leads.label.quotation": "အမှတ်အသားပေးသွင်းသည့်နေ့စွဲ",
    "leads.label.price": "စျေးနှုန်း",
    "leads.label.product": "လက်ကျန်ပစ္စည်း",
    "leads.label.charge_type": "ငွေသေးငွေပမာဏ",
    "leads.label.rate_uom": "ငွေမတန်း/UOM",
    "leads.label.download": "ဒေါင်းလုတ်",
    "leads.label.service_plan": "ဝန်ဆောင်မှုအစီအစဉ်",
    "leads.label.ADDRESSDETAILS": "လိပ်စာအသေးစိတ်",
    "leads.label.Individual": "ပုဂ္ဂလိက",
    "leads.label.Corporate": "ကုမ္ပဏီ",
    "leads.label.Type": "အမျိုးအစား",
    "leads.label.EditLead": "ခေါင်းဆောင်ကို တည်းဖြတ်",
  },
};
